const openChat = () => {
  try {
    window.HubSpotConversations.widget.open();
  } catch (error) {
    console.error("Failed to open chat", error);
  }
};

export default openChat;
